import { render, staticRenderFns } from "./DialogSuccess.vue?vue&type=template&id=290bb93e&lang=html"
import script from "./DialogSuccess.vue?vue&type=script&lang=js"
export * from "./DialogSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports